(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kk-mobile-atc"] && !Shopify.designMode) return;
  try {
    class KkMobileAtc extends HTMLElement {
    connectedCallback() {
      this.source = document.querySelector('.product-form__submit[id^="ProductSubmitButton-"]');
      this.button = this.querySelector('[data-kk-mobile-submit]');
      this.price = this.querySelector('[data-kk-mobile-price]');
      this.productInfo = document.querySelector('product-info');
      if (!this.source || !this.button || !this.productInfo) {
        this.remove();
        return;
      }

      this.button.addEventListener('click', () => {
        if (!this.source.disabled && this.source.getAttribute('aria-disabled') !== 'true') this.source.click();
      });

      this.sourceObserver = new IntersectionObserver(([entry]) => {
        this.sourceVisible = entry.isIntersecting;
        this.updateVisibility();
      });
      this.sourceObserver.observe(this.source);

      this.contentObserver = new MutationObserver(() => this.scheduleSync());
      this.contentObserver.observe(this.productInfo, { attributes: true, childList: true, subtree: true });
      this.visibilityHandler = () => this.updateVisibility();
      window.addEventListener('scroll', this.visibilityHandler, { passive: true });
      window.addEventListener('resize', this.visibilityHandler);
      this.sync();
    }

    disconnectedCallback() {
      this.sourceObserver?.disconnect();
      this.contentObserver?.disconnect();
      cancelAnimationFrame(this.syncFrame);
      window.removeEventListener('scroll', this.visibilityHandler);
      window.removeEventListener('resize', this.visibilityHandler);
      document.body.classList.remove('kk-mobile-atc-visible');
    }

    scheduleSync() {
      cancelAnimationFrame(this.syncFrame);
      this.syncFrame = requestAnimationFrame(() => this.sync());
    }

    sync() {
      const nextSource = this.productInfo.querySelector('.product-form__submit[id^="ProductSubmitButton-"]');
      if (nextSource && nextSource !== this.source) {
        this.sourceObserver.disconnect();
        this.source = nextSource;
        this.sourceObserver.observe(this.source);
      }
      const sourceLabel = this.source.querySelector('span')?.textContent.trim();
      const targetLabel = this.button.querySelector('span');
      const currentPrice = this.productInfo.querySelector('[id^="price-"]:not(.hidden) .price-item--sale') || this.productInfo.querySelector('[id^="price-"]:not(.hidden) .price-item--regular');
      const busy = this.source.classList.contains('loading');
      this.button.disabled = this.source.disabled || this.source.getAttribute('aria-disabled') === 'true';
      this.button.setAttribute('aria-busy', String(busy));
      this.button.classList.toggle('loading', busy);
      this.button.querySelector('.loading__spinner')?.classList.toggle('hidden', !busy);
      if (sourceLabel && targetLabel) targetLabel.textContent = sourceLabel;
      if (this.price) this.price.textContent = currentPrice?.textContent.trim() || '';
      this.updateVisibility();
    }

    updateVisibility() {
      const shouldShow = window.innerWidth < 750 && window.scrollY > 320 && !this.sourceVisible;
      this.classList.toggle('is-visible', shouldShow);
      this.toggleAttribute('inert', !shouldShow);
      this.setAttribute('aria-hidden', String(!shouldShow));
      document.body.classList.toggle('kk-mobile-atc-visible', shouldShow);
    }
  }

  if (!customElements.get('kk-mobile-atc')) customElements.define('kk-mobile-atc', KkMobileAtc);
  } catch(e) { console.error(e); }
})();

})();
